var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.$host() + "/"}},[_c('img',{attrs:{"src":require("assets/images/Te/TeCommon/Logo/logo-icon.svg"),"alt":"テックアカデミー","width":"50","height":"31"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }